import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for UploadForm */
const UploadFormScheme = Yup.object().shape({
    clientName_error: Yup.bool(),
    clientName_notselectable: Yup.bool(),
    binNumber: Yup.string()
        .required('Reference Number is required')
        .matches(
            /^[a-zA-Z0-9]{1,12}$/,
            'Reference Number must be alphanumeric character with maximum of 12 characters limit'
        ),
    clientName: Yup.string().when('clientName_error', {
        is: (val: boolean) => val === true,
        then: Yup.string().test(
            'len',
            'Please select a valid option from the list',
            (val) => typeof val === 'string' && val.length === 0
        ),
        otherwise: Yup.string().when('clientName_notselectable', {
            is: (val: boolean) => val === true,
            then: Yup.string().test(
                'len',
                'Please select a valid option from the list',
                (val) => typeof val === 'string' && val.length === 0
            ),
            otherwise: Yup.string().required('Checklist name is required'),
        }),
    }),
});

/** @constant {ObjectShape} - Yup Object extends default clientScheme used for UploadZone */
const UploadZoneScheme = UploadFormScheme.shape({
    attachment: Yup.array()
        .of(
            Yup.object()
                .shape({
                    name: Yup.string()
                        .required()
                        .test(
                            // eslint-disable-next-line max-len
                            'unmatched', // eslint-disable-next-line max-len
                            `File names must not start with a zero.`,
                            (val) => {
                                if (
                                    typeof String(val).match(/^(?:rw|rw_|)0+/i)
                                        ?.length === 'undefined'
                                ) {
                                    return true;
                                }
                                return false;
                            }
                        )
                        .matches(
                            // eslint-disable-next-line max-len
                            // /^([a-zA-Z0-9]{1,12})_(?:[^_]{0,12}|)(?:.+|)\.(zip|ZIP)$/i
                            /^(?![0])([a-zA-Z0-9]{1,12})_(?:[^_]{0,12}|)(?:[a-zA-Z0-9_]+)\.(zip|ZIP)$/,
                            // eslint-disable-next-line max-len
                            `Expected Initial File Format: Application number : Alphanumeric with 12 characters limit"\nNo special characters or spaces allowed. \nApplication number should not start with zero.`
                        ),
                })
                .required('File required')
        )
        .required('Upload file needed'),
});

export { UploadZoneScheme, UploadFormScheme };
